<template>
  <div class="index">
    <a-alert type="success" class="mb-20">
      <div slot="message">
        <span>当前账号：{{user.name}}</span>
        <a-divider type="vertical"></a-divider>
        <span>部门：{{user.office_path_name}}</span>
        <a-divider type="vertical"></a-divider>
        <span>上次登陆时间：{{user.login_info.login_at}}</span>
        <a-divider type="vertical"></a-divider>
        <span>登录IP {{user.login_info.ip}}</span>
        <a-divider type="vertical"></a-divider>
        <span>{{user.login_info.addr}}</span>
      </div>
    </a-alert>
    <a-card
      class="mb-20"
      title="待办事项"
      v-if="isAnyGranted(['post_manager.post_process_list.btn_look_up','job_manager.job_list.btn_look_up','company_manager.company_list.btn_look_up','clue_manager.job_clue.btn_look_up'])"
    >
      <a-row type="flex" align="middle" :gutter="40">
        <a-col
          span="6"
          :xxl="{span:4}"
          v-if="isGranted('post_manager.post_process_list.btn_look_up')"
        >
          <router-link
            class="box t1"
            tag="div"
            :to="{path: '/order/process',query:{tab: 'CREATED'}}"
          >
            <div class="title">新推荐</div>
            <div class="num">{{ post_count.toFixed(0) }}</div>
          </router-link>
        </a-col>
        <a-col span="6" :xxl="{span:4}" v-if="isGranted('job_manager.job_list.btn_look_up')">
          <router-link
            class="box t2"
            tag="div"
            :to="{path: '/post',query:{tab: 'DRAFT,PENDING',id:user.uid}}"
          >
            <div class="title">待审核职位</div>
            <div class="num">{{ job_count.toFixed(0) }}</div>
          </router-link>
        </a-col>
        <a-col
          span="6"
          :xxl="{span:4}"
          v-if="isGranted('company_manager.company_list.btn_look_up')"
        >
          <router-link
            class="box t3"
            tag="div"
            :to="{path: '/client-manage',query:{tab: 3,id:user.uid,name: user.name}}"
          >
            <div class="title">待审核公司</div>
            <div class="num">{{ company_count.toFixed(0) }}</div>
          </router-link>
        </a-col>
        <a-col span="6" :xxl="{span:4}" v-if="isGranted('clue_manager.job_clue.btn_look_up')">
          <router-link class="box t4" tag="div" :to="{path: '/cash/job',query:{tab: 'CREATE'}}">
            <div class="title">新职位变现</div>
            <div class="num">{{ job_clue_count.toFixed(0) }}</div>
          </router-link>
        </a-col>
      </a-row>
    </a-card>
    <User-data-board class="mb-20"></User-data-board>
    <Data-board></Data-board>
  </div>
</template>
<script>
import baseComponentVue from "@/components/base-component.vue";
import { Tween } from "@createjs/tweenjs";
import UserDataBoard from "./chart/User-data-board";
import DataBoard from "./chart/Data-board";
import Api from "@/api";
import { mapState } from "vuex";
export default {
  name: "dashboard",
  extends: baseComponentVue,
  data() {
    return {
      post_count: 0,
      job_count: 0,
      company_count: 0,
      job_clue_count: 0
    };
  },
  components: { UserDataBoard, DataBoard },
  computed: {
    ...mapState(["user"])
  },
  async mounted() {
    let response = await Api.dashboard.pendingData();
    let tween = Tween.get(this).to({ ...response }, 800);
  }
};
</script>
<style lang="scss" scoped>
.box {
  user-select: none;
  text-align: center;
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
  .title {
    line-height: 50px;
    font-size: 20px;
    background: #fff;
  }
  .num {
    height: 120px;
    color: #fff;
    font-size: 30px;
    line-height: 120px;
  }
  &.t1 {
    background: #00a2eb;
    .title {
      color: #00a2eb;
      border: 3px solid;
    }
  }
  &.t2 {
    background: #f3a719;
    .title {
      color: #f3a719;
      border: 3px solid;
    }
  }

  &.t3 {
    background: #2e5efd;
    .title {
      color: #2e5efd;
      border: 3px solid;
    }
  }
  &.t4 {
    background: #ff5405;
    .title {
      color: #ff5405;
      border: 3px solid;
    }
  }
}
</style>
